import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-49fb114a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "CodeMathRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "ft24"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请根据以上映射关系，选择正确的答案", -1));
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "ft40"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft40"
}, "= ?", -1));
const _hoisted_10 = {
  class: "ft22"
};
const _hoisted_11 = {
  class: "flex flex-col"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt32"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.map, (m, mi) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "width": "10%"
        },
        key: m,
        class: "flex flex-col bothCenter"
      }, [_createElementVNode("img", {
        src: m,
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString(mi), 1)]);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt32 bothCenter"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.number1, n => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "width": "10%"
        },
        key: `n1_${n}`,
        class: "flex flex-col bothCenter"
      }, [_createElementVNode("img", {
        src: $props.data.map[parseInt(n)],
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_6)]);
    }), 128)), _createElementVNode("span", _hoisted_7, _toDisplayString($props.data.mathType == 'ADD' ? '+' : $props.data.mathType == 'SUB' ? '-' : $props.data.mathType == 'MUT' ? 'x' : '÷'), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.number2, n => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "width": "10%"
        },
        key: `n2_${n}`,
        class: "flex flex-col bothCenter"
      }, [_createElementVNode("img", {
        src: $props.data.map[parseInt(n)],
        style: {
          "width": "100%"
        }
      }, null, 8, _hoisted_8)]);
    }), 128)), _hoisted_9]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_AnswerButtonGroup, {
      onChoose: $options.onChoosed,
      "option-both-center": false,
      review: $props.review,
      single: "",
      ref: "answerBtns",
      reviewMode: $props.reviewMode,
      options: $props.data.options
    }, {
      default: _withCtx(btnIndex => [_createElementVNode("span", _hoisted_10, _toDisplayString($props.data.options[btnIndex.index]), 1)]),
      _: 1
    }, 8, ["onChoose", "review", "reviewMode", "options"])]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_col, {
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1)]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        style: _normalizeStyle({
          color: $props.review.result ? 'green' : 'red'
        })
      }, "您的答案：" + _toDisplayString($props.review.answer), 5)]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}